export const SupportedFilesTypes : string[] = ['DOC','DOT','DOCX','DOTX','DOCM','DOTM','XLS','XLSX','PDF'/*,'RTF','TXT'*/];
export const SupportedFilesTypesLine : string = 'DOC, DOT, DOCX, DOTX, DOCM, DOTM, XLS, XLSX, PDF';//, RTF, TXT';